import "./App.css";

import React from "react";

import { keyframes } from "styled-components";
import { bounce } from "react-animations";
import FeelingBored from "./FeelingBored/FeelingBored";

import { Provider } from "react-redux";
import store from "./store";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import KeyConcepts from "./KeyConcepts";
import HookWrapper from "./HookWrapper";
import Home from "./Home";
import Navbar from "./Navbar";
import { ReduxState } from "./ReduxState/ReduxState";
import { LifeCycleLogs } from "./lifeCycleLogs/imgs/LifeCycleLogs";
import { About } from "./About/About";
import CssBaseline from '@material-ui/core/CssBaseline';
import { SideMenu } from "./SideMenu/SideMenu";
import Internals from "./Internals/Internals";
import jsx from "./Internals/jsx";

const bounceAnimation = keyframes`${bounce}`;

// const BounceDiv = styled.div`
//   animation: 10s ${bounceAnimation};
// `;

function App() {
  return (
    <Provider store={store}>
      <CssBaseline />
      <Router>
        <div className="bg" style={{ margin: "9px" }}>
          <Navbar />
          
          <div >
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/keyconcepts" component={KeyConcepts} />
              <Route path="/hooks" component={HookWrapper} />
              <Route path="/bored" component={FeelingBored} />
              <Route path="/redux" component={ReduxState} />
              <Route path="/lifecycle" component={LifeCycleLogs} />
              <Route path="/about" component={About} />
              <Route path="/internals" component={Internals} />
              <Route path="/jsx" component={jsx} />
            </Switch>
          </div>
        </div>
      </Router>
    </Provider>
  );
}
// https://privacyterms.io/view/IGrJ2CJc-XuKeVKbr-QLs3z7/
export default App;
